<template>
    <div class="box">
        <div class="header">
            <div class="logo pointer" @click="return_">
                <img src="../../static/images/logo.png" alt="">
            </div>
            <div class="header_right">

                <img @click="return_" src="../../static/images/brand/guanbi.png" alt="">
            </div>
        </div>
        <div class="topkongbox"></div>
        <div class="main" :style="{ 'min-height': screenHeight + 'px' }">
            <div class="mainkongbox"></div>
            <h1>{{$t('m.RetrievePWD_01')}}</h1>

            <div class="loginbox">

                <div class="inp_item">
                    <div class="inp_text">{{$t('m.login_04')}}：</div>
                    <div class="inp_"><input :placeholder="$t('m.RetrievePwd_01')" v-model="param.email"></div>
                </div>
                <div class="inp_item">
                    <div class="inp_text">{{$t('m.register_04')}}：</div>
                    <div class="inp_"><input class="yzm" v-model="param.email_code" :placeholder="$t('m.register_09')"></div>
                    <div class="btn pointer" @click="getcode" v-if="!if_send">{{$t('m.register_06')}}</div>
                    <div v-if="if_send" class="code_style">{{ code_time }}</div>
                </div>
                <div class="inp_item">
                    <div class="inp_text">{{$t('m.login_05')}}：</div>
                    <div class="inp_"><input :placeholder="$t('m.login_10')" type="password" v-model="param.password"></div>
                </div>
                <div class="inp_item">
                    <div class="inp_text">{{$t('m.register_05')}}：</div>
                    <div class="inp_"><input :placeholder="$t('m.register_10')" type="password" v-model="param.password2"></div>
                </div>

                <div class="btnbox" @click="confirm">
                    <el-button type="danger">{{$t('m.RetrievePWD_04')}}</el-button>
                </div>


            </div>

        </div>

    </div>
</template>
<script>
import encryption from '@/utils/encryption.js'
export default {
    data() {
        return {
            screenHeight: '',




            param: {
                email: '',
                password: '',
                password2: '',

                email_code: '',

            },
            code_time: 60,  //验证码保护器
            if_send: false  //是否发送了验证码
        }
    },
    mounted() {
        window.screenHeight = document.documentElement.clientHeight; //实时高度
        this.screenHeight = window.screenHeight - 80 - 25;

        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data

    },
    methods: {
         //获取验证码
        getcode() {
            let that = this
            if (!this.param.email) {
                this.$message.warning(this.$t('m.RetrievePwd_02'))
            } else {
                let param = {
                    email:this.param.email
                }
                let sing = encryption.getSing(param)
              
                this.$api.forget_send(param,sing).then((res) => {
                    if (res.data.code == 1) {
                        this.$message.success(this.$t('m.register_12'))
                        this.if_send = true
                        clearInterval(that.code_time);
                        let timer = setInterval(() => {
                            that.code_time--;
                            if (that.code_time <= 0) {
                                clearInterval(timer);
                                that.if_send = false;

                            }
                        }, 1000);
                    }
                })


            }
        },




        return_() {
            this.$router.push({
                path: '/'
            })
        },
        confirm() {
            let param = this.param
            if (!param.email) {
                this.$message.warning(this.$t('m.RetrievePwd_01'))
            } else if (!param.email_code) {
                this.$message.warning(this.$t('m.register_09'))
            } else if (!param.password) {
                this.$message.warning(this.$t('m.login_10'))
            } else if (!param.password2) {
                this.$message.warning(this.$t('m.register_10'))
            } else if (param.password2 != param.password) {
                this.$message.warning(this.$t('m.RetrievePWD_08'))
            } else {
                let sing = encryption.getSing(param)
                this.$api.forget_pwd(param, sing).then((res) => {
                    if (res.data.code == 1) {
                        this.$router.push({
                            path: '/account/registerSuccess?pageType=' + 2 + '&&email=' + this.param.email
                        })
                    }

                })



            }
        }



    }


}

</script>
<style lang="scss" scoped>
.topkongbox{
    height: 15px;
}
.main {
    width: 100%;
    
    background-image: url(../../static/images/brand/login_bac.png);
    background-size: 100% 100%;
    text-align: center;
    border-top: 5px solid #ef5843;
    h1 {
        text-align: center;
        font-size: 40px;
    }

    .mainkongbox {
        width: 100%;
        height: 100px;
    }

    .zhuce {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;

    }


    .loginbox {
        // margin: 70px 0;
        width: 370px;
        margin: 30px auto;

        .btnbox {
            margin-top: 70px;
            width: 100%;

            ::v-deep .el-button {
                width: 370px;
                height: 50px;
                background-color: #ef5843 !important;
            }
        }

        .upload_item {
            margin-top: 20px;


            width: 100%;

            p {
                padding: 0 20px;
            }

            .upload_box {
                margin-top: 20px;
            }
        }

        .inp_item {
            border-bottom: 1px solid #d0cece;
            display: flex;
            align-items: center;

            height: 60px;
            padding: 0 20px;

            width: 100%;

            .code_style {
                color: #ef5843;
            }

            .inp_text {
                width: 120px;

            }

            .btn {
                width: 85px;
                height: 30px;

                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                background-color: #FFF;
                color: #ef5843;
                border: 2px solid #ef5843;
                border-radius: 4px;
            }

            .yzm {
                width: 100px !important;
            }

            .inp_radio {
                display: flex;
                align-items: center;

                .radio {
                    display: flex;
                    align-items: center;

                    img {
                        width: 18px;
                        height: 18px;
                    }

                    span {
                        margin-left: 6px;
                    }
                }

                .radio:last-child {
                    margin-left: 30px;
                }

            }

            .inp_ {
                flex: 1;
                display: flex;

                input {

                    border: 0 !important;
                    margin-left: 10px;
                    height: 56px;
                    background-color: transparent;
                    outline: none;
                }
            }



        }



    }

    .agreement {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        margin-top: 30px;
    }
}

.header {

    width: 100%;
    height: 90px;

    background-color: #FFF;
    display: flex;
    justify-content: space-between;
    padding: 0 145px;
    align-items: center;

    .logo {
        img {
            width: 90px;
        }
    }

    .header_right {
        display: flex;
        align-items: center;

        img {
            width: 15px;
            height: 15px;
        }
    }
}

.gugestyle {
    border: 2px solid #4285f4;
    background-color: #4285f4;
}

.facebookstyle {
    border: 2px solid #3b5998;
    background-color: #3b5998;
}

.twitterstyle {
    border: 2px solid #000000;
    background-color: #fff;
    color: #000000 !important;
}

.border-right1 {
    border-right: 2px solid #4285f4;
}

.border-right2 {
    border-right: 2px solid #3b5998;
}

.border-right3 {
    border-right: 2px solid #000000;
}



	
	
	// 宽度小于1200px
	@media screen and (max-width: 1200px){

		.header{
			height: 2.5rem;
			padding: 0 1rem;
			.logo{
				img{
					width: 2.275rem;
					height: auto;
					display: block;
				}
			}
		}
		.mainkongbox{
			height: 3rem!important;
		}
		.main{
			.loginbox{
				width: 100%!important;
				padding: 0 1rem;
			}
			.loginbox1{
				width: 100%!important;
				padding: 0 1rem;
			}
			
			.inp_item{
				flex-wrap: wrap;
				height: auto!important;
				padding: 1rem 0!important;
				.inp_text{
					width: 100%!important;
					padding-bottom: 1rem;
					padding-left: 10px;
					text-align: left;
				}
				input{
					height: auto!important;
					// margin-left: 0!important;
				}
			}
		}
		.loginbox{
			width: 100%!important;
			padding: 0 1rem;
			margin: 0!important;
			padding-bottom: 3rem!important;
		}
		.loginbox1{
			width: 100%!important;
			padding: 0 1rem;
		}
		.topkongbox{
			height: 0;
		}
		h1{
			font-size: 1.5rem!important;
		}
		.agreement{
			padding: 1rem ;
			// padding-bottom: 4rem;
			display: block!important;
			.orange{
				display: inline-block;
			}
		}
		.btnbox{
			margin-top: 3rem!important;
		}
		::v-deep .el-button {
			width: 100%!important;
			font-weight: bold;
			height: 52px;
			margin: auto;
			display: block;
			background-color: #ef5843 !important;
		}
		::v-deep .el-dialog {
			// background-color: #f6f7fa;
			width: 90%!important;
			margin-top: 10%!important;
		}
	}
</style>